import { useTranslation } from 'react-i18next';

import { PlanName } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/components/MediaPlan/components/MediaPlanHeader/PlanName';

interface MediaPlanHeaderProps {
  trackSelection?: string;
  campaignObjective: string;
  campaignType: string;
}

export function MediaPlanHeader({
  trackSelection,
  campaignObjective,
  campaignType,
}: MediaPlanHeaderProps) {
  const { t } = useTranslation('campaign-planner');

  return (
    <div className="mb-md rounded-sm p-lg pt-md bg-emphasis-default">
      <PlanName />
      <div className="flex gap-xl divide-x-px">
        <div>
          <div className="mb-xs text-body-sm">
            {t('digitalCampaigns.mediaPlan.header.track')}
          </div>
          <div className="text-body-md">
            {trackSelection ||
              t('digitalCampaigns.mediaPlan.header.noTrackSelected')}
          </div>
        </div>
        <div className="pl-xl border-emphasis-subtle">
          <div className="mb-xs text-body-sm">
            {t('digitalCampaigns.mediaPlan.header.campaignObjective')}
          </div>
          <div className="text-body-md">{campaignObjective}</div>
        </div>
        <div className="pl-xl border-emphasis-subtle">
          <div className="mb-xs text-body-sm">
            {t('digitalCampaigns.mediaPlan.header.campaignType')}
          </div>
          <div className="text-body-md">{campaignType}</div>
        </div>
      </div>
    </div>
  );
}

MediaPlanHeader.displayName = 'MediaPlanHeader';
